import ReactDOM from "react-dom";
import "./index.css";
// import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { IntlProviderWrapper } from "IntlProviderWrapper";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import reducers from "./reducers";
import rootSaga from "./sagas";
import { RealmAppProvider } from "./RealmApp";
import RealmApolloProvider from "./graphql/RealmApolloProvider";
import "antd/dist/antd.css";
import { MessagingProvider } from "./context/MessagingContext";
import { I18nextProvider } from "react-i18next";
import i18next from "./i18n/i18next";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducers, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);
Chart.register(ChartDataLabels);

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey="6LdzVBQeAAAAAI0yHhr4LRhgdfcQAy9uP5dI2Vj0">
    <RealmAppProvider appId={process.env.REACT_APP_APP_ID}>
      <I18nextProvider i18n={i18next}>
        <RealmApolloProvider>
          <BrowserRouter>
            <Provider store={store}>
              <IntlProviderWrapper>
                <MessagingProvider>
                  <div id="divAppContainer">
                    <App />
                  </div>
                  <div id="fullScreenPopUp" />
                </MessagingProvider>
              </IntlProviderWrapper>
            </Provider>
          </BrowserRouter>
        </RealmApolloProvider>
      </I18nextProvider>
    </RealmAppProvider>
  </GoogleReCaptchaProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
